import React from 'react';

interface FooterProps {
    isMenuOpen: boolean;
}

const Footer: React.FC<FooterProps> = ({ isMenuOpen }) => {
    return (
        <footer className={isMenuOpen ? 'active' : ''}>
            <p>© Todos los derechos reservados.</p>
            <img className='logo' src="image/nuevo-logo.png" alt="Immunoconsultor logo" />
        </footer>
    );
};

export default Footer;
